<template>
  <DefaultLayout>
    <v-row class="mx-5 mt-5">
      <v-col cols="12">
        <h2 class="text-red-600 text-3xl font-inter font-bold">
          List User Kontraktor
        </h2>
        <p class="text-gray-500">
          Sini-Saja membantu mengelola & memantau perkembangan kegiatan
          kontraktor
        </p>

        <v-row class="mt-2 mb-4">
          <div class="flex justify-end w-full mb-4">
            <v-btn
              prepend-icon="mdi-account"
              class="bg-red-600 text-white capitalize"
              data-bs-toggle="modal"
              data-bs-target="#TambahUser"
            >
              Tambah User Kontraktor
            </v-btn>
          </div>
          <v-col cols="12" class="bg-white rounded-lg p-3 shadow-md">
            <div class="w-1/2 flex gap-3 items-center">
              <v-text-field
                variant="outlined"
                density="compact"
                color="red"
                hide-details
                clearable
                v-model="FormValues.kontraktorName"
                v-on:keyup.enter="cariKontraktor"
                prepend-inner-icon="mdi-magnify"
                placeholder="Masukkan Nama Kontraktor"
              ></v-text-field>
              <v-btn
                class="bg-red-600 text-white capitalize"
                @click="refreshPage()"
              >
                Refresh Filter
              </v-btn>
            </div>
          </v-col>

          <div class="mt-8 rounded-lg shadow-md">
            <v-data-table-server
              v-model:items-per-page="dataTable.pagination.itemsPerPage"
              :items-per-page-options="[5, 10, 25, 50, 100]"
              :headers="dataTable.headers"
              :items="dataTable.items"
              :items-length="dataTable.pagination.totalItems"
              @update:options="fetchData"
            >
              <template v-slot:item="{ item, index }">
                <tr
                  class="border-b border-gray-950 h-16"
                  :class="{ 'bg-gray-50': index % 2 !== 0 }"
                >
                  <td class="w-[50px] min-w-[50px] text-center">
                    {{ index + 1 }}
                  </td>
                  <td>{{ item.email }} <span v-if="item.isPjo" class="badge bg-primary">PJO</span></td>
                  <td>
                    {{ item.noHandphone != null ? item.noHandphone : "-" }}
                  </td>
                  <td>{{ item.namaKontraktor }}</td>
                  <td>{{ item.alamat }}</td>
                  <td>
                    <div class="gap-3">
                      <button
                        class="btn btn-outline-warning btn-sm me-2"
                        data-bs-toggle="modal"
                        data-bs-target="#EditUser"
                        @click="
                          openModal(
                            item.kontraktorId,
                            item.email,
                            item.noHandphone,
                            item.id,
                            item.isPjo
                          )
                        "
                      >
                        <font-awesome-icon
                          :icon="['fas', 'user-pen']"
                          size="sm"
                        />
                      </button>
                      <button
                        class="btn btn-outline-danger btn-sm"
                        @click="
                          DeleteItemUser(item.id, item.kontraktorId, item.email)
                        "
                      >
                        <font-awesome-icon :icon="['fas', 'trash']" />
                      </button>
                    </div>
                  </td>
                </tr>
              </template>
            </v-data-table-server>
          </div>
        </v-row>
      </v-col>
    </v-row>
  </DefaultLayout>

  <!--  Tambah User -->
  <div
    class="modal fade rounded-top-5"
    id="TambahUser"
    tabindex="-1"
    aria-labelledby="TambahUser"
    aria-hidden="true"
  >
    <div class="modal-dialog-centered rounded-top-5">
      <div
        class="modal-dialog modal-content card shadow-sm rounded-4 border-0"
        style="min-height: 156px; min-width: 350px"
      >
        <div
          class="modal-content rounded-bottom-5 rounded-top-4 border-0"
          style="
            min-height: 100px;
            min-width: 350px;
            background: rgba(181, 26, 26, 1);
          "
        >
          <div class="d-flex justify-content-end w-100 p-2">
            <button
              type="button"
              id="btnClose"
              @click="closeModal"
              class="btn"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <img
                src="../../assets/icons/close_whaite.png"
                alt="icon"
                width="24"
                height="24"
              />
            </button>
          </div>
          <div
            class="p-3 text-white text-center mb-3"
            style="font-family: Inter, sans-serif"
          >
            <h4 class="fw-bold">Tambah User Kontraktor</h4>
          </div>
        </div>
        <div class="modal-body">
          <div class="p-3">
            <form @submit.prevent="OnFormSubmit">
              <div class="form-group">
                <label for="email" class="form-label fs-8"
                  ><small>Email</small></label
                >
                <input
                  type="email"
                  class="form-control fs-9"
                  id="email"
                  v-model="FormValues.email"
                  autofocus
                  @input="validateEmail"
                  :class="{
                    'is-invalid': isEmailValid === false,
                    'is-valid': isEmailValid === true,
                  }"
                />
              </div>
              <div class="form-group">
                <label for="nohp" class="form-label fs-8"
                  ><small>No Handphone</small></label
                >
                <input
                  type="nohp"
                  class="form-control fs-9"
                  id="nohp"
                  placeholder="Format 628xxx | Karakter min 9, Max 14"
                  v-model="FormValues.noHandphone"
                  autofocus
                  @input="validatePhone"
                  :class="{
                    'is-invalid': isNoHpValid === false,
                    'is-valid': isNoHpValid === true,
                  }"
                />
              </div>
              <div class="form-group mt-3 mb-5">
                <label for="email" class="form-label fs-8"
                  ><small>Nama Kontraktor</small></label
                >
                <v-select
                  v-model="FormValues.kontraktorId"
                  :options="Kontraktor"
                  label="namaKontraktor"
                  placeholder="Pilih salah satu"
                  :reduce="(item) => item.id"
                  @search="FetchKontraktor"
                />
              </div>
              <div class="form d-flex align-items-center gap-2 custom-checkbox">
                <input class="form-check-input mb-2" type="checkbox" role="switch" id="isPjo" name="isPjo" v-model="FormValues.isPjo">
                <label for="nohp" class="form-label fs-8"><small>is PJO ?</small></label>
              </div>
              <div class="d-flex justify-content-center">
                <button
                  type="submit"
                  class="btn btn-sm bg-danger w-75 text-white"
                  :disabled="!isNoHpValid || !isEmailValid"
                >
                  Simpan
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--  End Tambah User -->

  <div
    class="modal fade rounded-top-5"
    tabindex="-1"
    id="EditUser"
    aria-labelledby="EditUser"
    aria-hidden="true"
    aria-modal="true"
    role="dialog"
  >
    <div class="modal-dialog-centered rounded-top-5">
      <div
        class="modal-dialog modal-content card shadow-sm rounded-4 border-0"
        style="min-height: 156px; min-width: 350px"
      >
        <div
          class="modal-content rounded-bottom-5 rounded-top-4 border-0"
          style="
            min-height: 100px;
            min-width: 350px;
            background: rgba(181, 26, 26, 1);
          "
        >
          <div class="d-flex justify-content-end w-100 p-2">
            <button
              type="button"
              id="btnClose"
              @click="closeModal"
              class="btn"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <img
                src="../../assets/icons/close_whaite.png"
                alt="icon"
                width="24"
                height="24"
              />
            </button>
          </div>
          <div
            class="p-3 text-white text-center mb-3"
            style="font-family: Inter, sans-serif"
          >
            <h4 class="fw-bold">Edit User Kontraktor</h4>
          </div>
        </div>
        <div class="modal-body">
          <div class="p-3">
            <form @submit.prevent="UpdateUser">
              <div class="form-group">
                <input
                  type="text"
                  class="form-control fs-9"
                  id="id"
                  v-model="FormValuesEdit.userId"
                  hidden="hidden"
                />
                <label for="email" class="form-label fs-8"
                  ><small>Email</small></label
                >
                <input
                  type="email"
                  class="form-control fs-9"
                  id="email"
                  @input="validateEmailEdit"
                  :class="{
                    'is-invalid': isEmailValid === false,
                    'is-valid': isEmailValid === true,
                  }"
                  v-model="FormValuesEdit.email"
                />
              </div>
              <div class="form-group">
                <label for="nohp" class="form-label fs-8"
                  ><small>No Handphone</small></label
                >
                <input
                  type="text"
                  class="form-control fs-9"
                  placeholder="Format 628xxx | Karakter min 9, Max 14"
                  id="nohp"
                  @input="validatePhoneEdit"
                  :class="{
                    'is-invalid': isNoHpValid === false,
                    'is-valid': isNoHpValid === true,
                  }"
                  v-model="FormValuesEdit.noHandphone"
                />
              </div>
              <div class="form-group mt-3 mb-5">
                <label for="email" class="form-label fs-8"
                  ><small>Nama Kontraktor</small></label
                >
                <v-select
                  v-model="FormValuesEdit.kontraktorId"
                  :options="Kontraktor"
                  label="namaKontraktor"
                  placeholder="Search and select..."
                  :reduce="(item) => item.id"
                  @search="FetchKontraktor"
                />
              </div>
              <div class="form d-flex align-items-center gap-2 custom-checkbox">
                <input class="form-check-input mb-2" type="checkbox" role="switch" id="isPjo" name="isPjo" v-model="FormValuesEdit.isPjo">
                <label for="isPjo" class="form-label fs-8"><small>is PJO ?</small></label>
              </div>
              <div class="d-flex justify-content-center">
                <button
                  type="submit"
                  class="btn btn-sm bg-danger w-75 text-white"
                >
                  Simpan
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import {
  API_BASE_URL,
  CMS_GET_INTERNAL_KONTRAKTOR,
  CMS_GET_USER_LIST,
  CMS_GET_USER_UPDATE,
  CMS_USER_REGISTER,
} from "@/constants";
import Swal from "sweetalert2";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import moment from "moment";
import vSelect from "vue-select";
import DefaultLayout from "@/layouts/DefaultLayout.vue";
import {
  CreateDataTableObject,
  SetDataTableResponse,
} from "@/utilities/DataTableHelpers";

export default {
  name: "MUserListKontraktorPage",
  components: {
    FontAwesomeIcon,
    DefaultLayout,
    vSelect,
  },
  data() {
    return {
      dataTable: CreateDataTableObject([
        { title: "No.", align: "start", sortable: false, width: "50px" },
        { title: "Email", align: "start", sortable: false },
        {
          title: "No Handphone",
          align: "start",
          sortable: false,
          width: "150px",
        },
        { title: "Nama Kontraktor", align: "start", sortable: false },
        { title: "Alamat", align: "start", sortable: false },
        { title: "Aksi", align: "start", sortable: false, width: "120px" },
      ]),
      Users: [],
      Kontraktor: [],
      currentPage: 1,
      perPage: 100,
      totalData: 0,
      FormValues: {
        keyword: "",
        perPage: 5,
        email: "",
        kontraktorId: "",
        NamaKontraktor: "",
        noHandphone: "",
        status: [1],
        kontraktorName: null,
        isPjo: false
      },
      FormValuesEdit: {
        userId: "",
        email: "",
        kontraktorId: null,
        NamaKontraktor: "",
        noHandphone: "",
        status: [1],
        isPjo: false
      },
      isModalVisible: false,
      modalTitle: "",
      modalContent: "",
      isEmailValid: null,
      isNoHpValid: null,
      filtersInitialized: false,
    };
  },
  created() {
    this.initFiltersFromQuery();
  },
  mounted() {
    this.initFiltersFromQuery();
    this.FetchKontraktor();
    this.filtersInitialized = true;
  },
  activated() {
    if (this.filtersInitialized) {
      this.initFiltersFromQuery();
      this.fetchData();
    }
  },
  methods: {
    initFiltersFromQuery() {
      const q = this.$route.query;
      if (q.kontraktorName) {
        this.FormValues.kontraktorName = q.kontraktorName;
      }
      if (q.page) {
        this.currentPage = parseInt(q.page) || 1;
        this.dataTable.pagination.page = this.currentPage;
      }
      if (q.perPage) {
        this.FormValues.perPage = parseInt(q.perPage) || 5;
        this.dataTable.pagination.itemsPerPage = this.FormValues.perPage;
      }
    },
    syncFiltersToUrl() {
      const query = {};
      if (this.FormValues.kontraktorName) {
        query.kontraktorName = this.FormValues.kontraktorName;
      }
      if (this.currentPage && this.currentPage !== 1) {
        query.page = this.currentPage;
      }
      if (this.FormValues.perPage && this.FormValues.perPage !== 5) {
        query.perPage = this.FormValues.perPage;
      }
      this.$router.replace({ query }).catch(() => {});
    },
    buildKontraktorQuery() {
      const query = {};
      if (this.FormValues.kontraktorName) {
        query.kontraktorName = this.FormValues.kontraktorName;
      }
      if (this.currentPage && this.currentPage !== 1) {
        query.page = this.currentPage;
      }
      if (this.FormValues.perPage && this.FormValues.perPage !== 5) {
        query.perPage = this.FormValues.perPage;
      }
      return query;
    },
    validateEmail() {
      if (this.FormValues.email.trim() === "") {
        this.isEmailValid = null;
      } else {
        const re =
          /^([a-zA-Z0-9_.+-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        this.isEmailValid = re.test(this.FormValues.email);
      }
    },
    validateEmailEdit() {
      if (this.FormValuesEdit.email.trim() === "") {
        this.isEmailValid = null;
      } else {
        const re =
          /^([a-zA-Z0-9_.+-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        this.isEmailValid = re.test(this.FormValuesEdit.email);
      }
    },
    validatePhone() {
      const phoneRegex = /^(?:62)[8][1-9][0-9]{6,11}$/; // Adjust pattern to fit rules
      if (this.FormValues.noHandphone.trim() === "") {
        this.isNoHpValid = null;
      } else {
        this.isNoHpValid = phoneRegex.test(this.FormValues.noHandphone);
      }
    },
    validatePhoneEdit() {
      const phoneRegex = /^(?:62)[8][1-9][0-9]{6,11}$/; // Adjust pattern to fit rules
      if (this.FormValuesEdit.noHandphone.trim() === "") {
        this.isNoHpValid = null;
      } else {
        this.isNoHpValid = phoneRegex.test(this.FormValuesEdit.noHandphone);
      }
    },
    openModal(kontraktorId, email, noHandphone, userId, isPjo) {
      this.isModalVisible = true;
      this.FormValuesEdit.email = email;
      this.FormValuesEdit.kontraktorId = kontraktorId;
      this.FormValuesEdit.userId = userId;
      this.FormValuesEdit.noHandphone = noHandphone;
      this.FormValuesEdit.isPjo = isPjo;
    },
    getKontraktorNameById(id) {
      const kontraktor = this.Kontraktor.find((item) => item.id === id);
      return kontraktor ? kontraktor.namaKontraktor : "-";
    },
    getAlamatKontraktorById(id) {
      const kontraktor = this.Kontraktor.find((item) => item.id === id);
      return kontraktor ? kontraktor.alamat : "-";
    },

    FetchKontraktor(searchTerm) {
      let bodyJSONKontraktor = {
        header: {
          page: this.currentPage,
          perPage: this.perPage,
          usecase: "isafe",
        },
      };
      axios
        .post(API_BASE_URL + CMS_GET_INTERNAL_KONTRAKTOR, bodyJSONKontraktor)
        .then((res) => {
          if (res.data.countData > 0) {
            this.Kontraktor = res.data.data;
            // console.log("data", this.Kontraktor = res.data.data);
            if (searchTerm) {
              const foundItem = res.data.data.find((item) => {
                let x = item.namaKontraktor.toLowerCase();
                return x.includes(searchTerm.toLowerCase());
              });
              if (
                !foundItem &&
                this.currentPage < Math.ceil(res.data.countData / this.perPage)
              ) {
                this.currentPage++;
                this.FetchKontraktor(searchTerm);
              } else {
                this.Kontraktor = foundItem ? [foundItem] : [];
              }
            }
          }
        })
        .catch((error) => {
          console.log(error);
          // if(error!=null){
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Terjadi kesalahan!",
          });
          // }
        });
    },
    resetPaginasi() {
      this.Users = [];
      this.FormValues.perPage = 5;
      this.currentPage = 1;
      this.totalData = 0;
    },
    cariKontraktor() {
      this.resetPaginasi();
      this.fetchData();
    },
    fetchData({ page, itemsPerPage } = {}) {
      if (page) {
        this.currentPage = page;
      }
      if (itemsPerPage) {
        this.FormValues.perPage = itemsPerPage;
      }
      this.syncFiltersToUrl();
      let bodyJson = {
        header: {
          page: this.currentPage,
          perPage: this.FormValues.perPage,
        },
        // sortBy: sortBy ? sortBy[0] : null,
        // sortDesc: sortDesc ? sortDesc[0] : null,
        status: this.FormValues.status,
        usecase: "kontraktor",
        kontraktorName: this.FormValues.kontraktorName,
      };
      const user = localStorage.getItem("user_cms");
      const tokens = JSON.parse(user);
      axios
        .post(API_BASE_URL + CMS_GET_USER_LIST, bodyJson, {
          headers: {
            role: "isafe",
            Authorization: `Bearer ${tokens.token}`,
            Accept: "application/json",
          },
        })
        .then((res) => {
          let result = {};
          console.log("result => ", res.data.users)
          result.data = res.data.users;
          result.total_data = res.data.totalData;
          result.total_per_page = this.FormValues.perPage;
          result.current_page = this.currentPage;

          this.dataTable = SetDataTableResponse(this.dataTable, result);

          this.Users = res.data.users;
          this.totalData = res.data.totalData;
        })
        .catch(() => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Terjadi kesalahan!",
          });
        });
    },

    OnFormSubmit() {
      this.validateEmail();
      this.validatePhone();
      const isEmailEmpty = this.FormValues.email.trim() === "";
      const isNoHpEmpty = this.FormValues.noHandphone.trim() === "";
      if (!this.isEmailValid || isEmailEmpty) {
        let errorMessage = "Email dan Nama Kontraktor tidak boleh kosong!";
        if (!this.isEmailValid) {
          errorMessage = "Alamat Email tidak valid!";
        }
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: errorMessage,
        });
      } else if (!this.isNoHpValid || isNoHpEmpty) {
        let errorMessage = "No Handphone tidak boleh Kosong!";
        if (!this.isNoHpValid) {
          errorMessage = "No Handphone tidak valid!";
        }
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: errorMessage,
        });
      } else {
        this.RegisterUser();
      }
    },
    async RegisterUser() {
      if (this.isEmailValid && this.isNoHpValid) {
        let bodyJSONCreate = {
          email: this.FormValues.email,
          noHandphone: this.FormValues.noHandphone,
          kontraktorId: this.FormValues.kontraktorId,
          isPjo: this.FormValues.isPjo,
          header: {
            usecase: "kontraktor",
          },
        };
        const user = localStorage.getItem("user_cms");
        const tokens = JSON.parse(user);
        axios
          .post(API_BASE_URL + CMS_USER_REGISTER, bodyJSONCreate, {
            headers: {
              role: "isafe",
              Authorization: `Bearer ${tokens.token}`,
              Accept: "application/json",
              // 'Access-Control-Allow-Origin': '*',
              // 'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE',
              // 'Access-Control-Allow-Headers': 'Content-Type, Authorization, Accept'
            },
          })
          .then(() => {
            this.FormValues = {
              email: "",
              kontraktorId: "",
            };
            setTimeout(() => {
              location.reload();
            }, 1500);
            Swal.fire({
              icon: "success",
              title: "User berhasil disimpan!",
              showConfirmButton: false,
              timer: 1300,
            });
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text:
                "Terjadi kesalahan saat simpan data user! (" +
                error.response.data.message +
                ")",
            });
          });
      }
    },

    UpdateUser() {
      // const currentDate = new Date(moment().format('YYYY-MM-DD HH:mm:ss'));
      let bodyJSONCreate = {
        userId: this.FormValuesEdit.userId,
        email: this.FormValuesEdit.email,
        noHandphone: this.FormValuesEdit.noHandphone,
        kontraktorId: this.FormValuesEdit.kontraktorId,
        status: 1,
        isPjo: this.FormValuesEdit.isPjo
        // updated_at: currentDate,
        // created_at: currentDate,
      };
      const user = localStorage.getItem("user_cms");
      const tokens = JSON.parse(user);
      axios
        .put(API_BASE_URL + CMS_GET_USER_UPDATE, bodyJSONCreate, {
          headers: {
            role: "isafe",
            Authorization: `Bearer ${tokens.token}`,
            Accept: "application/json",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE",
            "Access-Control-Allow-Headers":
              "Content-Type, Authorization, Accept",
          },
        })
        .then(() => {
          this.FormValuesEdit = {
            email: "",
            kontraktorId: "",
          };
          setTimeout(() => {
            location.reload();
          }, 1500);
          Swal.fire({
            icon: "success",
            title: "User berhasil diupdate!",
            showConfirmButton: false,
            timer: 1000,
          });
        })
        .catch(() => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Terjadi kesalahan saat menyimpan user!",
          });
        });
    },
    DeleteItemUser(userId, kontraktorId, email) {
      Swal.fire({
        title: "Konfirmasi",
        text: "Apakah Anda yakin ingin menghapus user ini?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Hapus!",
        cancelButtonText: "Batal",
      }).then((result) => {
        if (result.isConfirmed) {
          console.log("DeleteItemUser called with userId:", userId);
          const currentDate = new Date(moment().format("YYYY-MM-DD HH:mm:ss"));
          let bodyJSONCreate = {
            userId: userId,
            kontraktorId: kontraktorId,
            email: email,
            updated_at: currentDate,
            created_at: currentDate,
            status: 0,
          };
          const user = localStorage.getItem("user_cms");
          const tokens = JSON.parse(user);
          axios
            .put(API_BASE_URL + CMS_GET_USER_UPDATE, bodyJSONCreate, {
              headers: {
                role: "isafe",
                Authorization: `Bearer ${tokens.token}`,
                Accept: "application/json",
                // 'Access-Control-Allow-Origin': '*',
                // 'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE',
                // 'Access-Control-Allow-Headers': 'Content-Type, Authorization, Accept'
              },
            })
            .then(() => {
              this.Users = this.Users.filter((item) => item.userId !== userId);
              Swal.fire({
                icon: "success",
                title: "User berhasil dihapus!",
                showConfirmButton: false,
                timer: 1000,
              });
              location.reload();
            })
            .catch(() => {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Terjadi kesalahan saat menghapus user!",
              });
            });
        }
      });
    },
    refreshPage() {
      this.FormValues.kontraktorName = null;
      this.currentPage = 1;
      this.dataTable.pagination.page = 1;
      this.syncFiltersToUrl();
      this.fetchData();
    },
    closeModal() {
      (this.FormValues = {
        email: "",
        kontraktorId: "",
        noHandphone: "",
        kontraktorName: null,
      }),
        (this.FormValuesEdit = {
          email: "",
          kontraktorId: null,
          noHandphone: "",
        });
      this.isEmailValid = null;
      this.isNoHpValid = null;
    },
  },
};
</script>

<style scoped>
section {
  font-family: "Inter", sans-serif;
  font-style: normal;
  min-height: 100vh;
}
:deep(thead) {
  background-color: #fecaca;
}

.custom-checkbox input[type="checkbox"] {
  width: 20px;
  height: 20px;
  border: 2px solid #0d6efd; /* Bootstrap primary blue */
  border-radius: 4px;
  appearance: none;
  -webkit-appearance: none;
  outline: none;
  cursor: pointer;
  position: relative;
}

.custom-checkbox input[type="checkbox"]:checked {
  background-color: #0d6efd; /* fill blue when checked */
  border-color: #0d6efd;
}

.custom-checkbox input[type="checkbox"]::after {
  content: '';
  position: absolute;
  top: 3px;
  left: 6px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
  display: none;
}

.custom-checkbox input[type="checkbox"]:checked::after {
  display: block;
}
/* :deep(.v-data-table-footer) {
  background-color: #fecaca;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  overflow: hidden;
} */
</style>
